import React from 'react';
import {
  // Dashboard & Overview
  DashboardOutlined,
  AppstoreOutlined,
  
  // Users & Accounts
  UserOutlined,
  TeamOutlined,
  SolutionOutlined,
  IdcardOutlined,
  UserSwitchOutlined,
  MailOutlined,
  
  // Instructions & Transactions
  FileTextOutlined,
  FormOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  ScheduleOutlined,
  ClockCircleOutlined,
  HistoryOutlined,
  
  // Payments & Financial
  DollarOutlined,
  MoneyCollectOutlined,
  TransactionOutlined,
  SwapOutlined,
  BankOutlined,
  WalletOutlined,
  AccountBookOutlined,
  FundOutlined,
  
  // Cards
  CreditCardOutlined,
  IdcardFilled,
  
  // Documents
  FolderOutlined,
  FileOutlined,
  ContainerOutlined,
  FolderOpenOutlined,
  
  // Compliance & Security
  SafetyOutlined,
  SafetyCertificateOutlined,
  AuditOutlined,
  SecurityScanOutlined,
  
  // Precious Metals & Assets
  GoldOutlined,
  TrophyOutlined,
  
  // Digital & Crypto
  BlockOutlined,
  CloudOutlined,
  
  // Insurance & Protection
  InsuranceOutlined,
  
  // Settings & Admin
  SettingOutlined,
  ToolOutlined,
  ControlOutlined,
  
  // Support & Help
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  
  // Reports & Analytics
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  FundViewOutlined,
  
  // Workflows & Automation
  RobotOutlined,
  ApiOutlined,
  ThunderboltOutlined,
  
  // Other
  GlobalOutlined,
  EnvironmentOutlined,
  PictureOutlined,
  TableOutlined,
  ProfileOutlined,
  SnippetsOutlined,
  CrownOutlined,
  BuildOutlined,
  ReconciliationOutlined,
  NodeIndexOutlined,
  PartitionOutlined,
  DeploymentUnitOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
  
  // Developer & Documentation
  CodeOutlined,
  BookOutlined,
} from '@ant-design/icons';

/**
 * Menu Icons Map
 * 
 * Maps icon keys from the backend menu data to actual Ant Design icon components.
 * The keys should match what the backend sends in menuData[].icon
 */
export const menuIcons: Record<string, React.ReactNode> = {
  // Dashboard
  dashboard: <DashboardOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  appstore: <AppstoreOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  
  // Users & Accounts
  user: <UserOutlined />,
  UserOutlined: <UserOutlined />,
  team: <TeamOutlined />,
  TeamOutlined: <TeamOutlined />,
  solution: <SolutionOutlined />,
  SolutionOutlined: <SolutionOutlined />,
  idcard: <IdcardOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  userSwitch: <UserSwitchOutlined />,
  UserSwitchOutlined: <UserSwitchOutlined />,
  MailOutlined: <MailOutlined />,
  
  // Instructions & Transactions
  file: <FileTextOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  fileText: <FileTextOutlined />,
  form: <FormOutlined />,
  FormOutlined: <FormOutlined />,
  fileDone: <FileDoneOutlined />,
  FileDoneOutlined: <FileDoneOutlined />,
  fileSearch: <FileSearchOutlined />,
  FileSearchOutlined: <FileSearchOutlined />,
  schedule: <ScheduleOutlined />,
  ScheduleOutlined: <ScheduleOutlined />,
  clock: <ClockCircleOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  history: <HistoryOutlined />,
  HistoryOutlined: <HistoryOutlined />,
  
  // Payments & Financial
  dollar: <DollarOutlined />,
  DollarOutlined: <DollarOutlined />,
  moneyCollect: <MoneyCollectOutlined />,
  MoneyCollectOutlined: <MoneyCollectOutlined />,
  transaction: <TransactionOutlined />,
  TransactionOutlined: <TransactionOutlined />,
  swap: <SwapOutlined />,
  SwapOutlined: <SwapOutlined />,
  bank: <BankOutlined />,
  BankOutlined: <BankOutlined />,
  wallet: <WalletOutlined />,
  WalletOutlined: <WalletOutlined />,
  accountBook: <AccountBookOutlined />,
  AccountBookOutlined: <AccountBookOutlined />,
  fund: <FundOutlined />,
  FundOutlined: <FundOutlined />,
  
  // Cards
  creditCard: <CreditCardOutlined />,
  CreditCardOutlined: <CreditCardOutlined />,
  card: <CreditCardOutlined />,
  
  // Documents
  folder: <FolderOutlined />,
  FolderOutlined: <FolderOutlined />,
  folderOpen: <FolderOpenOutlined />,
  FolderOpenOutlined: <FolderOpenOutlined />,
  container: <ContainerOutlined />,
  ContainerOutlined: <ContainerOutlined />,
  
  // Compliance & Security
  safety: <SafetyOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  safetyCertificate: <SafetyCertificateOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  audit: <AuditOutlined />,
  AuditOutlined: <AuditOutlined />,
  securityScan: <SecurityScanOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  shield: <SafetyOutlined />,
  ShieldOutlined: <SafetyOutlined />,
  
  // Precious Metals & Assets
  gold: <GoldOutlined />,
  GoldOutlined: <GoldOutlined />,
  trophy: <TrophyOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  
  // Digital & Crypto
  block: <BlockOutlined />,
  BlockOutlined: <BlockOutlined />,
  cloud: <CloudOutlined />,
  CloudOutlined: <CloudOutlined />,
  
  // Insurance
  insurance: <InsuranceOutlined />,
  InsuranceOutlined: <InsuranceOutlined />,
  
  // Settings & Admin
  setting: <SettingOutlined />,
  SettingOutlined: <SettingOutlined />,
  tool: <ToolOutlined />,
  ToolOutlined: <ToolOutlined />,
  control: <ControlOutlined />,
  ControlOutlined: <ControlOutlined />,
  
  // Support & Help
  customerService: <CustomerServiceOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  question: <QuestionCircleOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  
  // Reports & Analytics
  barChart: <BarChartOutlined />,
  BarChartOutlined: <BarChartOutlined />,
  lineChart: <LineChartOutlined />,
  LineChartOutlined: <LineChartOutlined />,
  pieChart: <PieChartOutlined />,
  PieChartOutlined: <PieChartOutlined />,
  fundView: <FundViewOutlined />,
  FundViewOutlined: <FundViewOutlined />,
  
  // Workflows & Automation
  robot: <RobotOutlined />,
  RobotOutlined: <RobotOutlined />,
  api: <ApiOutlined />,
  ApiOutlined: <ApiOutlined />,
  thunderbolt: <ThunderboltOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  
  // Other / Legacy
  table: <TableOutlined />,
  TableOutlined: <TableOutlined />,
  global: <GlobalOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  environment: <EnvironmentOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />,
  picture: <PictureOutlined />,
  PictureOutlined: <PictureOutlined />,
  profile: <ProfileOutlined />,
  ProfileOutlined: <ProfileOutlined />,
  snippets: <SnippetsOutlined />,
  SnippetsOutlined: <SnippetsOutlined />,
  crown: <CrownOutlined />,
  CrownOutlined: <CrownOutlined />,
  build: <BuildOutlined />,
  BuildOutlined: <BuildOutlined />,
  reconciliation: <ReconciliationOutlined />,
  ReconciliationOutlined: <ReconciliationOutlined />,
  nodeIndex: <NodeIndexOutlined />,
  NodeIndexOutlined: <NodeIndexOutlined />,
  partition: <PartitionOutlined />,
  PartitionOutlined: <PartitionOutlined />,
  deploymentUnit: <DeploymentUnitOutlined />,
  DeploymentUnitOutlined: <DeploymentUnitOutlined />,
  
  // Developer & Documentation
  code: <CodeOutlined />,
  CodeOutlined: <CodeOutlined />,
  book: <BookOutlined />,
  BookOutlined: <BookOutlined />,
  
  // Legacy icon names (for backward compatibility)
  VerticalAlignMiddleOutlined: <ClockCircleOutlined />,  // Better icon for pending
  VerticalAlignTopOutlined: <FileTextOutlined />,  // Better icon for instructions
};

/**
 * Get icon by name with fallback
 */
export const getMenuIcon = (iconName: string | undefined): React.ReactNode => {
  if (!iconName) return <AppstoreOutlined />;
  return menuIcons[iconName] || <AppstoreOutlined />;
};
